import React, { createContext, useContext } from "react";
import axios from "axios";

// interfaces ---------------------------
interface DataProviderProps {
  children: React.ReactNode;
}

interface DataContextProps {
  getDataFromType: (type: string) => Promise<object[] | string[]>;
  getCollabWith: () => Promise<[]>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getNewDataFromType: (
    type: string,
    brandId?: string,
    collabId?: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) => Promise<[] | any>;
  getCoinValueFromField: (field: string) => Promise<string>;
  getLogoFromType: (field: string) => Promise<string>;
}
const host: string = import.meta.env.VITE_BACKEND_SERVER_URL;

export const StaticDataContext = createContext<DataContextProps | null>(null);

export const useStaticData = () => {
  return useContext(StaticDataContext);
};

export const StaticDataProvider: React.FC<DataProviderProps> = (props) => {
  // route-1 . get data from type ---------------------
  const getDataFromType = async (type: string) => {
    const result = await axios.get(`${host}/master/getData?type=${type}`);

    if (result.data.success) {
      const decodedData = new TextDecoder().decode(
        Uint8Array.from(atob(result.data.data), (c) => c.charCodeAt(0))
      );
      const parsedData = JSON.parse(decodedData);
      return parsedData;
    } else {
      alert("Error while fetching data");
    }
  };

  const getLogoFromType = async (type: string) => {
    const result = await axios.get(`${host}/master/getLogo?type=${type}`);

    if (result.data.success) {
      const decodedData = JSON.parse(atob(result?.data?.logo));
      return decodedData;
    } else {
      alert("Error while fetching data");
    }
  };

  // route-1 .get coin value from data ---------------------
  const getCoinValueFromField = async (field: string) => {
    const result = await axios.get(
      `${host}/master/getCoinValueOfField?field=${field}`
    );

    if (result.data.success) {
      return result?.data?.value ?? 0;
    } else {
      alert("Error while fetching data");
    }
  };

  const getNewDataFromType = async (
    type: string,
    brandId?: string,
    collabId?: string
  ) => {
    const result = await axios.get(
      `${host}/master/getDataV2?type=${type}&brandId=${brandId}&collabId=${collabId}`
    );

    if (result.data.success) {
      const decodedData = new TextDecoder().decode(
        Uint8Array.from(atob(result.data.data), (c) => c.charCodeAt(0))
      );
      const parsedData = JSON.parse(decodedData);
      return parsedData;
    } else {
      alert("Error while fetching data");
    }
  };

  // get collab with (company names, from influencer collab history list) ---------------------
  const getCollabWith = async () => {
    const result = await axios.get(`${host}/master/getCollabCompany`);

    if (result?.data?.success) {
      return result?.data?.collabWith;
    } else {
      alert("Error while fetching data");
    }
  };

  return (
    <StaticDataContext.Provider
      value={{
        getDataFromType,
        getCoinValueFromField,
        getLogoFromType,
        getCollabWith,
        getNewDataFromType,
      }}
    >
      {props?.children}
    </StaticDataContext.Provider>
  );
};
